module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Select new stretch delivery party"},"no":{"title":"Velg strekninger"}}')
  delete Component.options._Ctor
}
